import React, { useState, Component } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { vehicles } from '../data/vehicles';
import { ChevronLeft, ChevronRight, MessageCircle, Phone, Calendar, Gauge, Fuel, Settings, Palette, Car, CheckCircle2, Share2, Heart } from 'lucide-react';
export function VehicleDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const vehicle = vehicles.find(v => v.id === Number(id));
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  if (!vehicle) {
    return <div className="min-h-[60vh] flex flex-col items-center justify-center" data-id="element-307">
        <h2 className="text-2xl font-bold text-[#1C1C1C] mb-4" data-id="element-308">
          Vehículo no encontrado
        </h2>
        <button onClick={() => navigate('/')} className="px-6 py-2 bg-[#4A90E2] text-white rounded-lg hover:bg-[#3A7BC8] transition-colors" data-id="element-309">
          Volver al catálogo
        </button>
      </div>;
  }
  const nextImage = () => {
    setCurrentImageIndex(prev => prev === vehicle.gallery.length - 1 ? 0 : prev + 1);
  };
  const prevImage = () => {
    setCurrentImageIndex(prev => prev === 0 ? vehicle.gallery.length - 1 : prev - 1);
  };
  const handleWhatsApp = () => {
    const message = `Hola Lusso Group, estoy interesado en el ${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim} publicado a ${vehicle.price}.`;
    window.open(`https://wa.me/541139465079?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <div className="max-w-[1200px] mx-auto px-4 py-8" data-id="element-310">
      {/* Breadcrumb & Actions */}
      <div className="flex items-center justify-between mb-6" data-id="element-311">
        <button onClick={() => navigate('/')} className="flex items-center text-gray-600 hover:text-[#4A90E2] transition-colors" data-id="element-312">
          <ChevronLeft className="w-5 h-5 mr-1" data-id="element-313" />
          Volver
        </button>
        <div className="flex items-center gap-3" data-id="element-314">
          <button className="p-2 rounded-full bg-white border border-[#D5D5D5] text-[#1C1C1C] hover:text-[#4A90E2] hover:border-[#4A90E2] transition-colors shadow-sm" data-id="element-315">
            <Share2 className="w-5 h-5" data-id="element-316" />
          </button>
          <button className="p-2 rounded-full bg-white border border-[#D5D5D5] text-[#1C1C1C] hover:text-[#D4A800] hover:border-[#D4A800] transition-colors shadow-sm" data-id="element-317">
            <Heart className="w-5 h-5" data-id="element-318" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-319">
        {/* Left Column: Gallery & Description */}
        <div className="lg:col-span-2 space-y-8" data-id="element-320">
          {/* Main Gallery */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-[#D5D5D5]" data-id="element-321">
            <div className="relative aspect-[16/9] bg-[#E8E8E8] group" data-id="element-322">
              <img src={vehicle.gallery[currentImageIndex]} alt={`${vehicle.make} ${vehicle.model}`} className="w-full h-full object-contain" data-id="element-323" />

              {/* Gallery Controls */}
              <button onClick={prevImage} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm flex items-center justify-center text-[#1C1C1C] hover:bg-white hover:text-[#4A90E2] transition-all opacity-0 group-hover:opacity-100 shadow-md" data-id="element-324">
                <ChevronLeft className="w-6 h-6" data-id="element-325" />
              </button>
              <button onClick={nextImage} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm flex items-center justify-center text-[#1C1C1C] hover:bg-white hover:text-[#4A90E2] transition-all opacity-0 group-hover:opacity-100 shadow-md" data-id="element-326">
                <ChevronRight className="w-6 h-6" data-id="element-327" />
              </button>

              {/* Image Counter */}
              <div className="absolute bottom-4 right-4 px-3 py-1 rounded-full bg-black/50 backdrop-blur-sm text-white text-sm font-medium" data-id="element-328">
                {currentImageIndex + 1} / {vehicle.gallery.length}
              </div>
            </div>

            {/* Thumbnails */}
            <div className="flex gap-2 p-4 overflow-x-auto" data-id="element-329">
              {vehicle.gallery.map((img, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`relative flex-shrink-0 w-24 aspect-[4/3] rounded-lg overflow-hidden border-2 transition-all ${currentImageIndex === idx ? 'border-[#4A90E2]' : 'border-transparent hover:border-[#D5D5D5]'}`} data-id="element-330">
                  <img src={img} alt={`Thumbnail ${idx + 1}`} className="w-full h-full object-cover" data-id="element-331" />
                </button>)}
            </div>
          </div>

          {/* Description */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#D5D5D5]" data-id="element-332">
            <h3 className="text-xl font-bold text-[#1C1C1C] mb-4" data-id="element-333">
              Descripción del Vehículo
            </h3>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line" data-id="element-334">
              {vehicle.description}
            </p>
          </div>

          {/* Equipment */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#D5D5D5]" data-id="element-335">
            <h3 className="text-xl font-bold text-[#1C1C1C] mb-4" data-id="element-336">
              Equipamiento Destacado
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-337">
              {vehicle.equipment.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-338">
                  <CheckCircle2 className="w-5 h-5 text-[#4A90E2] flex-shrink-0 mt-0.5" data-id="element-339" />
                  <span className="text-gray-700" data-id="element-340">{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* Right Column: Info & CTAs */}
        <div className="space-y-6" data-id="element-341">
          {/* Price & Basic Info Card */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#D5D5D5] sticky top-6" data-id="element-342">
            <div className="mb-6" data-id="element-343">
              <h1 className="text-3xl font-bold text-[#1C1C1C] mb-2 leading-tight" data-id="element-344">
                {vehicle.year} {vehicle.make} {vehicle.model}
              </h1>
              <p className="text-lg text-gray-500 mb-4" data-id="element-345">{vehicle.trim}</p>
              <div className="text-4xl font-bold text-[#4A90E2]" data-id="element-346">
                {vehicle.price}
              </div>
            </div>

            {/* Quick Specs Grid */}
            <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-347">
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#E8E8E8]/50" data-id="element-348">
                <Calendar className="w-5 h-5 text-gray-500" data-id="element-349" />
                <div data-id="element-350">
                  <p className="text-xs text-gray-500" data-id="element-351">Año</p>
                  <p className="font-semibold text-[#1C1C1C]" data-id="element-352">{vehicle.year}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#E8E8E8]/50" data-id="element-353">
                <Gauge className="w-5 h-5 text-gray-500" data-id="element-354" />
                <div data-id="element-355">
                  <p className="text-xs text-gray-500" data-id="element-356">Kilometraje</p>
                  <p className="font-semibold text-[#1C1C1C]" data-id="element-357">
                    {vehicle.mileage}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#E8E8E8]/50" data-id="element-358">
                <Settings className="w-5 h-5 text-gray-500" data-id="element-359" />
                <div data-id="element-360">
                  <p className="text-xs text-gray-500" data-id="element-361">Transmisión</p>
                  <p className="font-semibold text-[#1C1C1C] text-sm" data-id="element-362">
                    {vehicle.transmission}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#E8E8E8]/50" data-id="element-363">
                <Fuel className="w-5 h-5 text-gray-500" data-id="element-364" />
                <div data-id="element-365">
                  <p className="text-xs text-gray-500" data-id="element-366">Combustible</p>
                  <p className="font-semibold text-[#1C1C1C]" data-id="element-367">{vehicle.fuel}</p>
                </div>
              </div>
            </div>

            {/* Detailed Specs List */}
            <div className="space-y-4 mb-8 border-t border-gray-100 pt-6" data-id="element-368">
              <div className="flex justify-between items-center" data-id="element-369">
                <span className="text-gray-500 flex items-center gap-2" data-id="element-370">
                  <Car className="w-4 h-4" data-id="element-371" /> Motor
                </span>
                <span className="font-medium text-[#1C1C1C] text-right" data-id="element-372">
                  {vehicle.engine}
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-373">
                <span className="text-gray-500 flex items-center gap-2" data-id="element-374">
                  <Palette className="w-4 h-4" data-id="element-375" /> Color
                </span>
                <span className="font-medium text-[#1C1C1C]" data-id="element-376">
                  {vehicle.color}
                </span>
              </div>
            </div>

            {/* CTAs */}
            <div className="space-y-3" data-id="element-377">
              <button onClick={handleWhatsApp} className="w-full py-4 px-6 rounded-xl bg-[#25D366] hover:bg-[#128C7E] text-white font-bold text-lg flex items-center justify-center gap-2 transition-colors shadow-md" data-id="element-378">
                <MessageCircle className="w-6 h-6" data-id="element-379" />
                Consultar por WhatsApp
              </button>
            </div>

            {/* Trust Badges */}
            <div className="mt-6 p-4 rounded-xl bg-[#E8E8E8]/50 flex items-start gap-3" data-id="element-380">
              <CheckCircle2 className="w-6 h-6 text-[#4A90E2] flex-shrink-0" data-id="element-381" />
              <div data-id="element-382">
                <h4 className="font-semibold text-[#1C1C1C] text-sm" data-id="element-383">
                  Garantía Lusso Group
                </h4>
                <p className="text-xs text-gray-500 mt-1" data-id="element-384">
                  Vehículo inspeccionado en 150 puntos. Documentación al día,
                  listo para transferir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}